import { ref } from 'vue'

export const CURRENT_VERSION = '0.6.0'

export interface ChangelogEntry {
  version: string
  date: string
  sections: { title: string; items: string[] }[]
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: '0.6.0',
    date: '01/09/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Modo Manutenção reformulado em torno de Ordens de Serviço (OS) numeradas, com fluxo de aprovação e painéis "Gerenciar OS" e "Consultar OS"',
          'Novo modo Portaria: pré-cadastro de visitantes esperados e registro de entrada/saída na obra',
          'Termo de Uso e Política de Privacidade publicados em /termos e /privacidade, com aceite obrigatório no cadastro',
          'Você agora pode baixar uma cópia dos seus dados ou solicitar a exclusão da sua conta direto pelo sistema',
          'Nova página "Notificações" com busca, filtros por tipo/período e carregamento automático ao rolar a lista',
          'Telas de carregamento (skeleton) em várias áreas do sistema, no lugar do "piscar" vazio→cheio'
        ]
      },
      {
        title: 'Correções',
        items: [
          'Login: senha errada não joga mais para a página inicial — agora mostra a mensagem de erro corretamente',
          'Chamados: erro no carregamento inicial agora é exibido, em vez de falhar silenciosamente'
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Popup de notificações (sino) mostra só as mais recentes, com atalho para a lista completa'
        ]
      },
      {
        title: 'Segurança',
        items: [
          'Bloqueio de conta após várias tentativas de login malsucedidas',
          'Respostas de erro do servidor não expõem mais detalhes internos ao cliente'
        ]
      }
    ]
  },
  {
    version: '0.5.3',
    date: '24/07/2026',
    sections: [
      {
        title: 'Segurança',
        items: [
          'Proteções adicionais contra abuso e acessos automatizados: limites de requisição na API, com limites dedicados para o assistente de IA e para envios de arquivos',
          'Reforço no acesso ao painel do administrador',
        ]
      }
    ]
  },
  {
    version: '0.5.2',
    date: '20/07/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Modo Manutenção: ao concluir uma rotina, o relatório em PDF é gerado e guardado no servidor — em vez de "Exportar PDF" agora é "Baixar relatório", e o "Visualizar" abre o PDF já pronto',
          'Página de Planos: conheça o plano Gratuito (todos os recursos, até 3 usuários, 1 projeto e 100MB) e os planos pagos com IA que estão chegando',
          'O site agora se atualiza sozinho para a nova versão — sem precisar clicar em "Atualizar"',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Nova página inicial com barra superior discreta (Login e Registro no topo, Planos e Saiba mais no centro)',
          'Painel do administrador (/administrador) repaginado: indicadores no topo, busca rápida com Ctrl+K e ação de entrar como a obra para dar suporte',
        ]
      },
      {
        title: 'Segurança',
        items: [
          'Verificação em duas etapas (2FA) para o painel do administrador, com código no celular/PC e códigos de recuperação de uso único',
          'Troca de senha do administrador direto pelo painel e proteções extras de acesso (lista de IPs, bloqueio por tentativas e registro de ações)',
        ]
      }
    ]
  },
  {
    version: '0.5.1',
    date: '19/07/2026',
    sections: [
      {
        title: 'Correções',
        items: [
          'Enviar manual para o estagiário: a interpretação de rotinas ficou consistente — antes o mesmo manual às vezes gerava poucas rotinas, agora o manual inteiro é lido e as rotinas são organizadas nas periodicidades corretas (diária, semanal, mensal...)',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Rotinas semelhantes do mesmo sistema são consolidadas numa rotina com checklist, em vez de dezenas de rotinas soltas',
        ]
      }
    ]
  },
  {
    version: '0.5.0',
    date: '19/07/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Manuais (Beta) no Modo Manutenção: envie o manual de operação e manutenção da atração em PDF, organizado em pastas por obra',
          'Enviar para o estagiário: a IA lê o manual e monta as rotinas de manutenção (diárias, semanais, mensais...) com checklist e página de referência — você escolhe os responsáveis, revisa e salva',
          'Alguma dúvida?: pergunte qualquer coisa sobre o manual e o EstagIArio Joe responde citando a página',
          'PDFs de até 100MB: o navegador comprime automaticamente antes de enviar (com botão de cancelar)',
          'Nova aba Armazenamento em Gerenciar Sistema: veja o espaço usado pela obra por categoria (arquivos, manuais, fotos, relatórios...)',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Grupos de rotinas agora aparecem minimizados no preview do estagiário e na aba Completar rotina — clique para expandir',
          'Cálculo de armazenamento agora considera tudo: fotos de relatórios, progresso do Gantt, DDS, presenças, almoxarifado e chamados',
        ]
      },
      {
        title: 'Correções',
        items: [
          'Interpretação de manuais grandes não falha mais (e ficou ~6x mais rápida)',
          'Compressão de PDFs pesados não trava mais — e preserva o texto e as tabelas do manual',
        ]
      }
    ]
  },
  {
    version: '0.4.1',
    date: '14/07/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Requisições de Compra: clique no card (ou no botão "Visualizar") para abrir a RC em tela cheia, com todos os detalhes e itens — foto, nome, descrição, link, quantidade e valores',
          'Requisições de Compra: edição em tela cheia, no lugar do formulário que aparecia acima da lista',
        ]
      },
      {
        title: 'Correções',
        items: [
          'Editar uma RC agora mostra e salva os itens requisitados (antes apareciam vazios e as alterações não eram gravadas)',
          'Aprovar/Reprovar RC voltou a funcionar',
          'Foto do item da RC agora carrega corretamente',
          'Valor estimado do item e fornecedor sugerido não se perdem mais ao salvar',
        ]
      }
    ]
  },
  {
    version: '0.4.0',
    date: '14/07/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Estagiário Joe conectado ao sistema: consulta obras, tarefas, estoque, relatórios, tickets, pendências, presença e requisições de compra — e prepara relatórios, tarefas e chamados com confirmação na tela',
          'Joe com memória de conversa: lembra o contexto de conversas longas (resumo automático, sem custo extra de tokens)',
          'Joe: abertura de chamados pelo chat e indicador "digitando" enquanto responde',
          'Requisição de Itens no relatório: peça ferramentas/materiais direto do formulário — vira Requisição de Compra automática no Escritório',
          'Escritório: exportação de RCs em Excel e encaminhamento automático por email (tela "Gerenciar Escritório")',
        ]
      },
      {
        title: 'Correções',
        items: [
          'Joe: removido o aviso "Encontrei um rascunho salvo" que aparecia toda vez ao abrir o chat; agora o chat sempre abre em conversa nova (as anteriores ficam na barra lateral)',
          'Fotos de progresso de tarefa agora são salvas corretamente em disco',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Plantas e documentos de projeto agora exigem login para download (não são mais públicos)',
          'Sistema mais rápido e leve: banco otimizado com índices e arquivos migrados para armazenamento em disco',
        ]
      }
    ]
  },
  {
    version: '0.3.0',
    date: '03/07/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Gantt: atividades sem data definida — opção "Sem data" ao criar/editar tarefa, exibidas em seção separada "Sem data definida" fora da linha do tempo, com botão "Agendar" para definir a data depois',
          'Gantt: barra de status/filtros modernizada — busca por título/descrição, chips de status (Não iniciadas / Em andamento / Concluídas / Atrasadas / Sem data) com contadores, e progresso geral do projeto',
          'Relatório do Gantt: intervalo de datas customizável (De/Até) além da navegação por semana, e modo "Somente sem data" para exportar só as atividades sem data definida',
          'Link compartilhado, exportação em Excel e PDF do Gantt agora incluem as atividades sem data definida em uma seção própria',
        ]
      },
      {
        title: 'Correções',
        items: [
          'Corrigido: editar uma tarefa e clicar em outra reabria o painel da tarefa recém-editada em vez da nova selecionada',
          'Corrigido: foto anexada na atualização de progresso não era enviada ao servidor (descartada antes da chamada à API)',
        ]
      }
    ]
  },
  {
    version: '0.2.10',
    date: '26/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Notificações com navegação: ao clicar, o usuário é direcionado para a tela correspondente (tarefa, ticket ou almoxarifado)',
          'Relatório semanal no Gantt: botão "Relatório" abre modal com resumo da semana, progresso e prévia das próximas tarefas',
          'Visualização de impressão / PDF direto do Gantt: abre SubmissionPrintPreview em tela cheia com edição, tradução e exportação',
          'Co-autores: novo campo no relatório com picker de usuários, chips e dropdown pesquisável',
          'Auto-logout por 401: backend retornando 401 encerra sessão e redireciona ao login automaticamente',
          'Aviso de relatório duplicado: banner âmbar ao criar relatório com tipo + projeto + data já existentes',
          'Popup "Criar" multi-modo: botão Criar no sidebar abre modal centralizado com opções por modo',
          'EstagIArio: confirmação antes de apagar chat; aba "Recentemente apagados" com restaurar/apagar definitivo',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Formulário de relatório redesenhado: barra de contexto fixa, barra inferior fixa com Cancelar / Salvar / Enviar',
          'Tipo de relatório: linha recolhível com chevron, expande ao clicar e fecha ao selecionar',
          'Atividades, maquinário e observações: drag-to-reorder com ghost customizado; exclusão com flip card + colapso vertical',
          'Botão "Modo IA" por item (ao lado do Excluir) com sugestão inline abaixo da descrição',
          'Sidebar: botões Criar centralizados e coloridos por modo (cinza, amarelo, verde, laranja); ícone de casa no modo Construção',
        ]
      }
    ]
  },
  {
    version: '0.2.9',
    date: '18/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Modo Escritório: novo modo de operação entre Almoxarifado e Administrador',
          'Feature flag "office" no painel de módulos — habilite/desabilite por obra',
          'Permissão officeAccess por cargo — controle quem acessa o Modo Escritório',
          'Logs do admin: seletor de tipo (Log de Ações / Login Logs), paginação com números de página e dropdown de resultados por página',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Painel admin de obra com sidebar lateral, URL por aba e aba Visão Geral (métricas, armazenamento, contrato, datas, módulos)',
          'Workspace de projeto: URL por aba e botão Voltar nos relatórios',
          'Sidebar mobile no admin de obra com botão ☰',
        ]
      }
    ]
  },
  {
    version: '0.2.8',
    date: '18/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Admin de obra: sidebar lateral de navegação substitui abas do topo — cada seção com URL própria (/usuarios, /projetos, /dados, etc.)',
          'Aba "Visão Geral" no admin de obra: métricas de usuários ativos/inativos/total, projetos ativos, armazenamento, contrato/plano, datas e módulos',
          'Admin de obra no celular: botão ☰ abre sidebar como drawer com backdrop',
          'Logs: seletor de tipo (Log de Ações / Login Logs), paginação com números e reticências, dropdown de resultados por página (10/25/50/100)',
          'Workspace de projeto: clicar em cada aba atualiza a URL (/resumo, /planejamento, /relatorios, etc.) com suporte a histórico do navegador',
          'Botão "Voltar à lista" ao visualizar um relatório no workspace',
        ]
      },
      {
        title: 'Correções',
        items: [
          'Métricas da Visão Geral (usuários ativos/inativos/projetos) não carregavam — resolvido expondo valores como computeds explícitos',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Campo de busca oculto na sidebar no celular',
        ]
      }
    ]
  },
  {
    version: '0.2.7',
    date: '18/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Página Anotações: CRUD completo com cards, modal de criação/edição e confirmação de exclusão',
          'Botão "Anotações" no menu do perfil (navbar) — acessível de qualquer tela',
          'IA sugere anotar quando não consegue identificar a ação desejada ("Quer que eu anote para você?")',
          'IA suporta intent "copy": copiar dados de um relatório existente para um novo',
        ]
      },
      {
        title: 'Técnico',
        items: [
          'Backend: tabela annotations com CRUD (GET/POST/PATCH/DELETE /annotations)',
          'Frontend: annotationsStore com refresh/create/update/remove',
          'IA /ia/analyze: novos intents copy e suggest_annotate no prompt Pass 1',
          'IAChatPanel: fluxo sim/não para salvar anotação sugerida pela IA',
        ]
      }
    ]
  },
  {
    version: '0.2.6',
    date: '18/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Modo IA (Estagiário): chat completo com histórico por sessão, sugestões rápidas e painel lateral de rascunho de relatório',
          'Avatar Castor no hero e nas mensagens do assistente IA',
          'Reconhecimento de voz via Web Speech API — transcreve diretamente na textarea do chat',
          'Seletor de idioma do microfone na sidebar da IA (10 idiomas: PT-BR, PT-PT, EN, ES, FR, DE, IT, ZH, JA)',
          'Histórico de chats: busca, navegação entre sessões e exclusão individual por chat',
          'Sidebar da IA abre como drawer no celular (botão ☰ no canto superior esquerdo)',
          'Ícones PWA atualizados para Castor Degradê em todos os tamanhos (mobile, desktop, Apple Touch)',
          'Favicon atualizado para Castor 900px Degradê',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Tema do sistema (cores da navbar/sidebar) carregado corretamente ao acessar /ia diretamente (F5)',
          'Microfone oculto ao focar na textarea do chat IA',
          'Placeholder da textarea do chat: "Do que precisa?"',
          'ia-brand-badge na sidebar usa logotipo ObraTycoon (ot-transparente.png)',
        ]
      },
      {
        title: 'Técnico',
        items: [
          'IAView.vue: nova view com DashboardNavbar + IAChatPanel, carrega systemStore.refresh() no mount',
          'useSystemTheme composable: extrai applySystemTheme de DashboardView para reuso',
          'Backend: endpoint POST /ia/analyze com Google Gemini 2.5 Flash (two-pass intent detection)',
          'Backend: dependência @google/generative-ai adicionada',
        ]
      }
    ]
  },
  {
    version: '0.2.5',
    date: '17/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Modo Construção: "Modo Padrão" renomeado — acesso controlado por permissão de cargo',
          'Modo Almoxarifado: seletor de sistema com nav dedicada (Estoque, Solicitações, Maquinário)',
          'Permissões por cargo: canManageConstruction e canManageMaintenance agora são por cargo, não globais',
          'Usuários sem acesso ao Modo Construção são redirecionados automaticamente ao modo disponível',
          'Painel de cargos: seletores de permissão para Construção e Manutenção no formulário de cargo',
        ]
      },
      {
        title: 'Técnico',
        items: [
          'roles: colunas maintenanceAccess e constructionAccess no banco (default 0 e 1 respectivamente)',
          'DashboardSidebar: warehouseMode computed, template block dedicado para Modo Almoxarifado',
          'Redirecionamento automático pós-load de cargos para usuários sem modo construção',
        ]
      }
    ]
  },
  {
    version: '0.2.4',
    date: '17/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Configurações de perfil divididas em abas com URL própria (/profile/editar, /seguranca, /email, /aparencia, /offline, /notificacoes, /versoes)',
          'PWA instalável como app no desktop — botão "Instalar como app" no menu do usuário e na aba Offline',
          'Window Controls Overlay: quando instalado, a navbar vira a barra de título nativa da janela',
        ]
      },
      {
        title: 'Técnico',
        items: [
          'ProfileEditView reescrito como shell fino — cada aba é um componente .vue independente',
          'installPromptStore: captura beforeinstallprompt, detecta instalação, expõe promptInstall()',
          'manifest.json: display_override WCO, id, scope, description, background_color atualizado',
          'CSS env(titlebar-area-*) e -webkit-app-region: drag no modo window-controls-overlay',
        ]
      }
    ]
  },
  {
    version: '0.2.3',
    date: '17/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Modo Manutenção como página completa (/manutencao) com navbar e sidebar visíveis — sem overlay',
          'Sistema de modos com URLs prefixadas: /geral/* para Modo Padrão, /admin/* para Modo Administrador',
          'Botão "Mudar sistema" no sidebar com popup de opções (Padrão, Administrador, Manutenção)',
          'Label de modo ativo no rodapé do sidebar',
          'Web Push: notificações em background no Android, Windows e iOS PWA mesmo com app fechado',
          'Banner "Nova versão disponível" na parte inferior da tela ao detectar atualização',
          'Botão "Forçar atualização" nas configurações para limpar cache e atualizar o app manualmente',
        ]
      },
      {
        title: 'Técnico',
        items: [
          '/administrador renomeado do antigo /admin para liberar /admin como prefixo de modo obra',
          'VAPID (Web Push): chaves salvas em env, tabela push_subscriptions, sendWebPush() em todas as notificações',
          'Service Worker: handlers push e notificationclick para exibir alertas nativos do SO',
          'swUpdateStore: detecta SW waiting e aciona applySwUpdate() para atualização sem Ctrl+Shift+R',
        ]
      }
    ]
  },
  {
    version: '0.2.2',
    date: '16/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Manutenção: aba "Completar rotina" — pendências agrupadas por grupo, botão Iniciar abre formulário com todas as rotinas do grupo de uma vez',
          'Manutenção: suporte a múltiplos tipos de resposta por rotina (Foto, Texto, Check) no mesmo formulário',
          'Navbar redesenhada no estilo M365: avatar, nome completo, @username, Configurações, Mais informações e Sair',
          'Botão "Mais informações" na navbar abre popup com mensagem sobre a autoria do sistema',
          'Textos e cores dos status de manutenção ("Pronto"/"Pendente") configuráveis pelo admin',
          'Status "Pendente criação de rotina" (roxo) nos cards quando não há grupos/rotinas cadastrados',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          '"Manter logado" funcionando corretamente — sessão não é mais perdida ao reiniciar o browser',
          'Rotinas já concluídas no período não aparecem mais em "Completar rotina"',
          'Badge da aba "Completar rotina" mostra apenas rotinas pendentes deduplicas por ciclo',
          'Fotos de conclusão de rotina comprimidas automaticamente para ~200KB',
          'Cards de obras em proporção 1:1 consistente',
        ]
      }
    ]
  },
  {
    version: '0.2.1',
    date: '15/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Localizador de RDO em formato Gantt — blocos por dia, agrupamento por atração, legenda por máquina',
          'Filtros colapsáveis com badge de filtros ativos em Relatórios, Localizador de Maquinário e RDO',
          'Sistema de Pendências: lista, visualização, criação, edição e remoção com foto e responsável',
          '"+ Criar" no menu lateral com dropdown "Criar atividade" e "Registrar pendência"',
          'Módulo de Manutenção (fundação): grupos, rotinas, tarefas e notificações automáticas',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Ferramentas (Maquinário) em relatórios: exibe nome da máquina em vez do ID interno',
          'SSE corrigido: token enviado via query param, resolvendo 401 contínuo após login',
        ]
      }
    ]
  },
  {
    version: '0.2.0',
    date: '12/06/2026',
    sections: [
      {
        title: 'Novo',
        items: [
          'Visualização de impressão (print preview) inline para documentos, com renderização A4 dentro do dashboard',
          'Seletor de idioma com 11 idiomas no preview (PT, EN, ES, DE, FR, IT, ZH, JA, KO, RU, NL)',
          'Modo edição no preview: alterar tamanho de fotos com P / M / G ou % personalizado e editar texto inline',
          'Fotos lado a lado: botão ⊞ para parear duas fotos adjacentes em uma linha',
          'Estado do preview salvo por documento — tamanhos de imagens e edições persistem ao fechar e reabrir',
          'Exportação PDF respeitando tamanhos e layouts de imagem (doc único e todos os documentos)',
          'Redesign completo da página de configurações do usuário com navegação por abas',
          'Sistema de histórico de navegação: todos os botões "Voltar" usam histórico interno com fallback inteligente',
          'Modo offline: service worker + IndexedDB, sincronização automática ao reconectar, aviso de status',
          'Navbar com customização de texto da marca (Sistema → Obra → Texto personalizado)',
          'Painel administrativo redesenhado com visual M365 (login split-panel + command bar + pivot tabs)',
        ]
      },
      {
        title: 'Melhorias',
        items: [
          'Data visível nas listas de relatórios no celular (substituindo a descrição)',
          'Sidebar com botão "Modo Padrão" sempre visível no iPhone (correção do iOS Safari)',
          'Senhas de usuários migradas para bcrypt automaticamente',
          'Botões Voltar corrigidos em todas as views com fallback correto por seção',
        ]
      },
      {
        title: 'Segurança',
        items: [
          'Lockout de conta do master admin após 5 tentativas falhas',
          'IP allowlist configurável para o painel administrativo',
          'Script CLI para gerenciar contas master sem senha no código-fonte',
        ]
      }
    ]
  }
]

const _hasNewVersion = ref(false)

export const versionStore = {
  hasNewVersion: _hasNewVersion,

  setNewVersion() {
    _hasNewVersion.value = true
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then(reg => {
        if (reg) reg.update().catch(() => {/* ignore */})
      }).catch(() => {/* ignore */})
    }
  },

  dismiss() {
    _hasNewVersion.value = false
  }
}
